import { ActionOptions, ActionProvider } from '@capturum/builders/core';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EmptyAction implements ActionProvider {
  public execute(options: ActionOptions, item: any, context?: Record<string, any>): any {
    return item;
  }
}
